import React, { useMemo } from 'react'
import { Box, CircularProgress, Grid, Typography } from '@mui/material'
import CheckinNetworkDetector from '../../network/components/CheckinNetworkDetector'
import {
  ChronoEventHeader,
  ChronoPageHeader,
} from '@eventops/chronotrack-ctlive-mui'
import { CheckinPageProps } from '../../../pages/CheckinPage'
import { useStyles } from '../../../hooks/useStyles'
import { createLogger } from '../../../app/logger'
import useCheckinSettings from '../hooks/useCheckinSettings'
import { CheckinSettingsLoading } from '../../../app/types'
import moment from 'moment-timezone'

// eslint-disable-next-line no-unused-vars
const logger = createLogger({
  prefix: 'CheckinPageContainer',
})

export type CheckinPageContainerProps = {
  headerText: string
  children: React.ReactNode
  topLevel?: React.ReactNode
  pageHeader?: React.ReactNode
} & CheckinPageProps

const CheckinPageContainer = (props: CheckinPageContainerProps) => {
  const { topLevel, pageHeader, headerText, children } = props
  const { classes } = useStyles()
  const checkinSettingsLoading: CheckinSettingsLoading = useCheckinSettings()
  const { checkinAllSettings, isLoadingCheckinSettings } = checkinSettingsLoading
  const { event } = checkinAllSettings

  const checkinClosed = useMemo(() => {
    if (checkinAllSettings.settings) {
      const currentDate = moment().unix()
      const { startDateTime, endDateTime } = checkinAllSettings.settings
      const start = startDateTime || currentDate
      const end = endDateTime || currentDate
      return start > currentDate || currentDate > end
    }
    return false
  }, [checkinAllSettings])

  return (
    <>
      {topLevel}
      <Grid container item xs={12} className={classes.mainGrid}>
        <Grid item xs={12}>
          <Box className={classes.appVersion}>v{process.env.REACT_APP_VERSION}</Box>
          <CheckinNetworkDetector data-cy={!props['data-cy'] ? undefined : `${props['data-cy']}-network-detector`} />
          <ChronoEventHeader event={event} />
          <Grid
            container
            item
            xs={12}
            id='pageHeader'
            className={classes.dataTable}
          >
            <ChronoPageHeader headerText={headerText} showDivider={false}>
              {pageHeader}
            </ChronoPageHeader>
          </Grid>
          {isLoadingCheckinSettings ? (
            <Box display='flex' justifyContent='center'>
              <CircularProgress size={40} thickness={4} />
            </Box>
          ) : checkinClosed ? (
            <Typography align='center' variant='h2'>
              Checkin is currently closed
            </Typography>
          ) : (
            children
          )}
        </Grid>
      </Grid>
    </>
  )
}

export default CheckinPageContainer
